import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const ModalRoot = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: stretch;
`

export const ButtonBase = styled.button`
display: flex;
align-items: center;
justify-content: center;
background-color: white;
border-radius: 6.75px;
border-color: rgba(0,0,0,0.1);
border-width: 1px;
cursor: pointer;
`

export const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid gray;
    padding: 21px;
`

export const ModalHeaderTitle = styled.div`
font-size: 17.5px;
font-weight: bold;
`

export const ModalHeaderSubtitle = styled.div`
font-size: 14px;
color: #717182;
`

export const ModalHeaderCloseButton = styled(ButtonBase)`
width: 31.5px;
height: 31.5px;

`

export const ModalHeaderTitleWrapper = styled.div`
`

export const ModalBody = styled.div`
    margin: 15px;
    border-radius: 10px;
    border: 1px solid grey;
    flex-grow: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 31.5px;
    columns: 2;
    padding: 15px;
    font-size: 14px;
    row-gap: 22px;
    column-gap: 14px;
`

export const ModalBodyTitle = styled.div`
    grid-column: 0;
    grid-row: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 7px;
`

export const ModalBodyDownloadButton = styled(ButtonBase)`
    grid-column: 2;
    grid-row: 1;
    justify-content: space-between;
    justify-self: end;
    padding: 8.75px 11px;
    gap: 13px;
`

export const ValueGroup = styled.div<{ span?: boolean }>`
${props => props.span && css`grid-column: 1 / 3`}
display: flex;
flex-direction:column;
align-items: stretch;
gap: 6.75px;
`

export const ValueLabel = styled.span`
font-size: 12.25px;
color: #0A0A0A;
`

export const ValueContainer = styled.span`
background-color: #F3F3F5;
border-color: rgba(0,0,0,0.1);
padding: 5.25px 10.5px;
min-height: 31.5px;
max-height: fit-content;
border-radius: 6.75px;
opacity: 50%;
`